import { useFormContext } from 'react-hook-form';

const LinkInputPreview = ({ source }: { source: string }) => {
    const { watch } = useFormContext();
    const value = watch(source);
    // TODO check value is object
    console.log("LinkInputPreview", source, value);

    if (value.url) {
        return <a href={value.url} target="_blank" rel="noreferrer">{value.url}</a>
    } else if (value.src) {
        return <a href={value.src} target="_blank" rel="noreferrer">{value.src}</a>
    } else if (value.file) {
        return <a href={value.file} target="_blank" rel="noreferrer">{value.file}</a>
    } else if (value.id) {
        return <a href={value.id} target="_blank" rel="noreferrer">{value.id}</a>
    } else if (value) {
        return <a href={value} target="_blank" rel="noreferrer">{value}</a>
    }
    return null;
}

export default LinkInputPreview;